import { ApiCoupon } from '@/models/api/coupon'
import LabelMaker from '@/models/api/coupon/label/labelMaker'

export default interface Coupon {
  index: number
  isBrandCoupon: boolean
  isCommonCoupon: boolean
  brandEnglishName?: string
}

class CouponBase {
  constructor(
    private readonly raw: ApiCoupon,
    public readonly index: number
  ) {}

  get id(): string {
    return this.raw.id
  }

  get imageUrl(): string {
    return this.raw.imageUrl
  }

  get title(): string {
    return this.raw.title
  }

  get labelMaker(): LabelMaker {
    return this.raw.labelMaker
  }

  get statusLabel(): string {
    return this.raw.statusLabel
  }

  get startAt(): Date {
    return this.raw.startAt
  }

  get endAt(): Date {
    return this.raw.endAt
  }
}

export class BrandCoupon extends CouponBase implements Coupon {
  public readonly isBrandCoupon = true
  public readonly isCommonCoupon = false

  constructor(
    public readonly brandEnglishName: string,
    raw: ApiCoupon,
    public readonly index: number
  ) {
    super(raw, index)
  }
}

export class CommonCoupon extends CouponBase implements Coupon {
  public readonly isBrandCoupon = false
  public readonly isCommonCoupon = true
}
